/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/online-store/asset
 * API Version: 2022-01
 */

import { UniqueValidationId } from "../../database/validations/keys";
import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyAssetKey,
  ShopifyAssetKeyUniquenessValidationKey,
  ShopifyAssetToShopKey,
  ShopifyAssetToThemeKey,
  ShopifyShopKey,
  ShopifyThemeKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyAssetKey,
  defaultFilterableApiIdentifiers: ["key"],
  "2022-01": {
    name: "Shopify Asset",
    fields: [
      {
        name: "Attachment",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "attachment" } },
      },
      {
        name: "Checksum",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "checksum" } },
      },
      {
        name: "Content Type",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "content_type" } },
      },
      {
        name: "Key",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "key" } },
        validations: {
          [ShopifyAssetKeyUniquenessValidationKey]: {
            key: ShopifyAssetKeyUniquenessValidationKey,
            specID: UniqueValidationId,
            configuration: {
              values: {
                scopeByField: ShopifyAssetToThemeKey,
              },
            },
          },
        },
      },
      {
        name: "Public URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "public_url" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Size",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "size" } },
      },
      {
        name: "Theme",
        fieldType: FieldType.BelongsTo,
        key: ShopifyAssetToThemeKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "theme_id" } },
        configuration: {
          relatedModelKey: ShopifyThemeKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyAssetToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_sublist", resource: "asset", parent: "theme" },
  },
  "2025-04": {
    graphQLTypename: "OnlineStoreThemeFile",
    fields: [
      {
        name: "Attachment",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "attachment" } },
        isDeleted: true,
      },
      {
        name: "Checksum",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "checksum", graphQLFieldKey: "checksumMd5" } },
      },
      {
        name: "Content Type",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "content_type", graphQLFieldKey: "contentType" } },
      },
      {
        name: "Key",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "key", graphQLFieldKey: "filename" } },
        validations: {
          [ShopifyAssetKeyUniquenessValidationKey]: {
            key: ShopifyAssetKeyUniquenessValidationKey,
            specID: UniqueValidationId,
            configuration: {
              values: {
                scopeByField: ShopifyAssetToThemeKey,
              },
            },
          },
        },
      },
      {
        name: "Public URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "public_url" } },
        isDeleted: true,
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at", graphQLFieldKey: "createdAt" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at", graphQLFieldKey: "updatedAt" } },
      },
      {
        name: "Size",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "size", graphQLFieldKey: "size" } },
      },
      {
        name: "Theme",
        fieldType: FieldType.BelongsTo,
        key: ShopifyAssetToThemeKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "theme_id", graphQLFieldKey: "themeId", skipGraphQLSelection: true },
        },
        configuration: {
          relatedModelKey: ShopifyThemeKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      parent: "themes",
      resource: "theme.files",
    },
  },
};

export const ShopifyAsset = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
